export default __webpack_public_path__ + "static/media/turn-sharp-left.754a3aa8.svg";